import { Theme, ThemeOptions } from '@mui/material/styles'

export default function Typography(
  theme: Theme,
  fontFamily: string,
): ThemeOptions['typography'] {
  return {
    fontFamily,
    h6: {
      fontWeight: 600,
      color: theme.palette.text.dark,
      fontSize: '0.75rem',
    },
    h5: {
      fontSize: '0.875rem',
      color: theme.palette.text.dark,
      fontWeight: 500,
      lineHeight: '1.5rem',
    },
    h4: {
      fontSize: '1rem',
      color: theme.palette.text.dark,
      fontWeight: 500,
    },
    h3: {
      fontSize: '1.25rem',
      color: theme.palette.text.dark,
      fontWeight: 500,
    },
    h2: {
      fontSize: '1.5rem',
      color: theme.palette.text.dark,
      fontWeight: 700,
    },
    h1: {
      fontSize: '2rem',
      color: theme.palette.text.dark,
      fontWeight: 700,
    },
    subtitle1: {
      fontSize: '0.875rem',
      fontWeight: 500,
      color: theme.palette.text.secondary,
    },
    subtitle2: {
      fontSize: '0.75rem',
      fontWeight: 400,
      color: theme.palette.text.secondary,
    },
    caption: {
      fontSize: '0.75rem',
      color: theme.palette.text.secondary,
      fontWeight: 400,
    },
    body1: {
      fontSize: '1rem',
      fontWeight: 400,
      lineHeight: '1.5rem',
      color: theme.palette.text.primary,
    },
    body2: {
      fontSize: '0.875rem',
      letterSpacing: '0em',
      fontWeight: 400,
      lineHeight: '1.5em',
      color: theme.palette.text.primary,
    },
    button: {
      textTransform: 'capitalize',
    },
  }
}
